import Vue from 'vue'
import VueRouter from 'vue-router'



import Home from '../views/Home.vue'

Vue.use(VueRouter);





function loggedInRedirectDashboard(to, from, next) {
  if (localStorage.token) {
    next('/');
  } else {
    next();
  }
}

function isLoggedIn(to, from, next) {
  if (localStorage.token) {
    next();
  } else {
    next('/login');
  }
}










  const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/auth/login.vue'),
    beforeEnter: loggedInRedirectDashboard,
  },
  {
    path: '/',
    name: 'Home',
    // component: Home,
    component: () => import('../views/suratKeluar/konsepSuratKeluar.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/usulanLokasiAbsen',
    name: 'usulanLokasiAbsen',
    component: () => import('../views/verifikasiLokasiAbsen/usulanLokasiAbsen.vue'),
    beforeEnter: isLoggedIn,
  },


  {
    path: '/agendaSuratMasuk',
    name: 'agendaSuratMasuk',
    component: () => import('../views/suratMasuk/agendaSuratMasuk.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/disposisiSuratMasuk',
    name: 'disposisiSuratMasuk',
    component: () => import('../views/suratMasuk/disposisiSuratMasuk.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/laporanDisposisi',
    name: 'laporanDisposisi',
    component: () => import('../views/suratMasuk/laporanDisposisi.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/verifikasiDisposisi',
    name: 'verifikasiDisposisi',
    component: () => import('../views/suratMasuk/verifikasiDisposisi.vue'),
    beforeEnter: isLoggedIn,
  },


  {
    path: '/agendaSuratKeluar',
    name: 'agendaSuratKeluar',
    component: () => import('../views/suratKeluar/agendaSuratKeluar.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/konsepSuratKeluar',
    name: 'konsepSuratKeluar',
    component: () => import('../views/suratKeluar/konsepSuratKeluar.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/ttdSuratKeluar',
    name: 'ttdSuratKeluar',
    component: () => import('../views/suratKeluar/ttdSuratKeluar.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/verifikasiSuratKeluar',
    name: 'verifikasiSuratKeluar',
    component: () => import('../views/suratKeluar/verifikasiSuratKeluar.vue'),
    beforeEnter: isLoggedIn,
  },

  
  {
    path: '/masterLevel',
    name: 'masterLevel',
    component: () => import('../views/dataMaster/authorization/masterLevel.vue'),
    beforeEnter: isLoggedIn,
  },


  {
    path: '/borangAcu',
    name: 'borangAcu',
    component: () => import('../views/dataMaster/masterOffice/borangAcu.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/M_JenisSurat',
    name: 'M_JenisSurat',
    component: () => import('../views/dataMaster/masterOffice/JenisSurat.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/M_bentukSurat',
    name: 'M_bentukSurat',
    component: () => import('../views/dataMaster/masterOffice/bentukSurat.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/M_klasifikasiSurat',
    name: 'M_klasifikasiSurat',
    component: () => import('../views/dataMaster/masterOffice/klasifikasiSurat.vue'),
    beforeEnter: isLoggedIn,
  },
  {
    path: '/M_sifatSurat',
    name: 'M_sifatSurat',
    component: () => import('../views/dataMaster/masterOffice/sifatSurat.vue'),
    beforeEnter: isLoggedIn,
  },

  {
    path: '/historyAkses',
    name: 'historyAkses',
    component: () => import('../views/dataMaster/masterOffice/historyAkses.vue'),
    beforeEnter: isLoggedIn,
  },



  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    beforeEnter: isLoggedIn,
  },


]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router
